import { render, staticRenderFns } from "./AuditDetail.vue?vue&type=template&id=185f224c&scoped=true"
import script from "./AuditDetail.vue?vue&type=script&lang=js"
export * from "./AuditDetail.vue?vue&type=script&lang=js"
import style0 from "./AuditDetail.vue?vue&type=style&index=0&id=185f224c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f224c",
  null
  
)

export default component.exports